import 'material-design-lite/material.min.js';

const MaterialImports = {
    componentHandler: window.componentHandler
};

delete window.componentHandler;

export default MaterialImports;